'use es6';

import I18n from 'I18n';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import { jsx as _jsx } from "react/jsx-runtime";
export function getVerboseDateText(timestamp) {
  const momentTimestamp = I18n.moment(timestamp);
  return /*#__PURE__*/_jsx(FormattedDateTime, {
    value: momentTimestamp,
    format: "lll",
    type: "userTz"
  });
}
getVerboseDateText.displayName = 'getVerboseDateText';